import request from 'store/utils/request';

export const CANCEL_GET_ACCOUNTS_REQUEST_ID = 'get-accounts-request';
// eslint-disable-next-line import/prefer-default-export
export const getAccountsRequest = async params => {
  try {
    return await request.get('/accounts/', {
      params,
      requestId: CANCEL_GET_ACCOUNTS_REQUEST_ID,
    });
  } catch (error) {
    throw error;
  }
};
